<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">
					You are applying for:<span>{{ pageTitle }}</span>
				</div>
				<div class="text">
					Fill the form below accurately indicating your potential suitability to job applying for.
				</div>
				<div class="form_box footer_box">
					<div class="input_box">
						<div class="tit">First name</div>
						<input v-model="firstVal" :class="isClick && !firstVal ? 'error' : ''" />
						<div v-show="isClick && !firstVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Last name</div>
						<input v-model="lastVal" :class="isClick && !lastVal ? 'error' : ''" />
						<div v-show="isClick && !lastVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Email</div>
						<input v-model="emailVal" :class="isClick && !emailVal ? 'error' : ''" />
						<div v-show="isClick && !emailVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Phone</div>
						<input v-model="phoneVal" :class="isClick && !phoneVal ? 'error' : ''" />
						<div v-show="isClick && !phoneVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">State</div>
						<input v-model="stateVal" :class="isClick && !stateVal ? 'error' : ''" />
						<div v-show="isClick && !stateVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Postal code</div>
						<input v-model="postalCodeVal" :class="isClick && !postalCodeVal ? 'error' : ''" />
						<div v-show="isClick && !postalCodeVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">City</div>
						<input v-model="cityVal" :class="isClick && !cityVal ? 'error' : ''" />
						<div v-show="isClick && !cityVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="">
							If hired, would you be able to present evidence of your U.S. citizenship or proof of your legal right to work in the United States? (Note: While lack of U.S. citizenship does not disqualify you for all positions, it may for those that require extensive U.S. travel.)
						</div>
						<van-radio-group v-model="radio1">
							<van-radio name="1">Yes</van-radio>
							<van-radio name="2">No</van-radio>
						</van-radio-group>
					</div>
					<div class="input_box">
						<div class="tit">Desired start date</div>
						<div :class="isClick && !timeVal ? 'date_err' : ''">
							<el-date-picker
								v-model="timeVal"
								type="date"
								placeholder=""
							>
							</el-date-picker>
						</div>
						<div v-show="isClick && !timeVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Upload Resume</div>
						<div class="unload_box">
							<el-upload
								class="upload-demo"
								action="/apis/api/index/uploads"
								name="files"
								:show-file-list="false"
								:on-success="handleAvatarSuccess"
								:multiple="false"
								:limit="1"
								:file-list="fileList"
							>
								<div class="">Upload files</div>
							</el-upload>
						</div>
						<div class="uploaded_box">{{ files }} <span v-if="filesUrl" @click="delFiles">删除</span></div>
						<div v-show="isClick && !filesUrl" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="tit">Cover letter</div>
						<textarea v-model="coverLetterVal"  :class="isClick && !coverLetterVal ? 'error' : ''" style="height: 80px;line-height: 20px;"></textarea>
						<div v-show="isClick && !coverLetterVal" class="error_tit">Please complete this required field.</div>
					</div>
					<div class="input_box">
						<div class="">
							Are you able to provide three (3) relevant references for your work? (Note: We will not ask for references at this stage in the hiring process).
						</div>
						<van-radio-group v-model="radio2">
							<van-radio name="1">Yes</van-radio>
							<van-radio name="2">No</van-radio>
						</van-radio-group>
					</div>
					<div class="input_box">
						<div class="tit">Where did you hear about this position?</div>
						<input v-model="positionVal" :class="isClick && !positionVal ? 'error' : ''" />
						<div v-show="isClick && !positionVal" class="error_tit">Please complete this required field.</div>
					</div>
					
					<div class="input_box" @click="checkbox = !checkbox">
						<div class="">
							Acceptance<span style="color: #f2545b;">*</span><br />
							<el-checkbox v-model="checkbox"></el-checkbox> I certify that the information contained in this application is true and complete. I understand that false information may be grounds for not hiring me or for immediate termination of employment if I am hired. I authorize the verification of any and all information listed above.
						</div>
						<div v-show="isClick && !checkbox" class="error_tit">Please complete this required field.</div>
					</div>
					<div v-show="isClick && !lastVal && !firstVal && !emailVal" class="tips_box">
						<div class="error">Please complete all required fields.</div>
					</div>
					<div class="btn_box_f">
						<div class="btn_box_ty btn_box" @click="subClick">
							Apply<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<van-popup v-model="sussessShow" :style="{ width: '80%' }" closeable @close="closePop" :close-on-click-overlay="false">
			<div class="sussess_box">
				<div class="img_box">
					<img src="../../assets/img_h5/组 316@2x.png" />
				</div>
				<div class="tit">Thank You</div>
				<div class="txt">
					Your application was sent succesfully. Someone from our team will get in touch.
				</div>
			</div>
		</van-popup>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import { careersFormSubmit, uploadFiles } from '@/api/public_h5';
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isClick: false,
			firstVal: '',
			lastVal: '',
			emailVal: '',
			phoneVal: '',
			stateVal: '',
			postalCodeVal: '',
			cityVal: '',
			coverLetterVal: '',
			positionVal: '',
			radio1: '',
			radio2: '',
			timeVal: '',
			files: '',
			filesUrl: '',
			fileList: [],
			checkbox: false,
			isClick: false,
			pageTitle: '',
			sussessShow: false,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		if(sessionStorage.getItem('careersName')) {
			that.pageTitle = sessionStorage.getItem('careersName');
			document.title = sessionStorage.getItem('careersName') + ' - CorDx';
			that.isLoading = false;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//删除附件
		delFiles() {
			this.files = '';
			this.filesUrl = '';
			this.fileList = [];
		},
		//上传附件
		handleAvatarSuccess(res, file) {
			this.filesUrl = res.data.thumb;
			this.files = file.name;
		},
		subClick() {
			let that = this;
			that.isClick = true;
		},
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.checkbox && that.emailVal && that.firstVal && that.lastVal && that.phoneVal && that.stateVal && that.postalCodeVal && that.cityVal && that.timeVal && that.coverLetterVal && that.positionVal && that.filesUrl) {
				that.$toast.loading({
					forbidClick: true,
				});
				careersFormSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					state: that.stateVal,
					postal_code: that.postalCodeVal,
					city: that.cityVal,
					is_zhengming: that.radio1,
					start_date: moment(that.timeVal).valueOf(),
					resume: that.filesUrl,
					cover_letter: that.coverLetterVal,
					is_word: that.radio2,
					source: that.positionVal,
					careers: that.pageTitle,
				}).then(res => {
					that.$toast.clear();
					that.firstVal = '';
					that.lastVal = '';
					that.emailVal = '';
					that.phoneVal = '';
					that.stateVal = '';
					that.postalCodeVal = '';
					that.cityVal = '';
					that.coverLetterVal = '';
					that.positionVal = '';
					that.radio1 = '';
					that.radio2 = '';
					that.timeVal = '';
					that.files = '';
					that.filesUrl = '';
					that.fileList = [];
					that.checkbox = false;
					that.isClick = false;
					that.sussessShow = true;
				});
			}
		},
		closePop() {},
	}
}
</script>

<style lang="less" scoped>
.sussess_box{
	width: 100%;
	padding: 42px 0 84px 0;
	text-align: center;
	background-image: linear-gradient(180deg,  #F9FAFE 100%, #FFFFFF 20%);
	.txt{
		font-size: 24px;
	}
	.tit{
		padding: 20px 0 20px 0;
		font-size: 42px;
	}
	.img_box{
		img{ width: 80%; }
	}
}
.main_box{
	width: 100%;
	height: auto;
	/*块1*/
	.block_1{
		padding: 42px 20px 64px 20px;
		.text{
			padding-bottom: 36px;
			font-size: 20px;
		}
		.title{
			padding-bottom: 10px;
			font-size: 34px;
			span{
				font-size: 34px;
				font-weight: bold;
			}
		}
	}
}
</style>
<style scoped>
.footer_box{
	padding: 20px;
	background-color: #F9FAFE;
}
.footer_box .input_box .tit::after{
	content: '*';
	color: #ff0000;
}
.footer_box .input_box input, .footer_box .input_box textarea, .footer_box .input_box select{
	width: 100%;
	background-color: #ffffff;
	color: #33475b;
	height: 42px;
	line-height: 21px;
	border: 1px solid #cbd6e2;
	padding: 10px;
}
.footer_box .input_box input.error{
	border-color: #c87872;
}
.footer_box .input_box textarea.error{
	border-color: #c87872;
}
.footer_box .input_box select.error{
	border-color: #c87872;
}
.footer_box .tips_box{
	margin-top: 0.84px;
}
.footer_box .tips_box .error{
	font-size: 14px;
	font-family: helvetica;
	color: #f2545b;
}
.footer_box .error_tit{
	color: #f2545b;
	font-size: 14px;
}
.footer_box .input_box_father{
	display: flex;
}
.footer_box .input_box{
	flex: 1;
	padding-bottom: 0.784px;
}
.footer_box .input_box .tit{
	color: #0B318F;
}
.footer_box .input_box_father .input_box:last-child{
	margin-left: 15px;
}
.footer_box .input_box_father .input_box:first-child{
	margin-right: 15px;
}
.footer_box .btn_box{
	margin: 21px 0;
}
</style>
<style scoped>
>>> .form_box .van-radio{
	margin: 0.84px 0;
}
>>> .van-radio__icon--checked .van-icon{
	background: #0B318F;
	border-color: #0B318F;
}
>>> .form_box .el-radio__input.is-checked .el-radio__inner, >>> .form_box .el-checkbox__input.is-checked .el-checkbox__inner{
	background: #0B318F;
	border-color: #0B318F;
}
>>> .form_box .el-checkbox__inner:hover{
	border-color: #0B318F !important;
}
>>> .form_box .el-radio__input.is-checked+.el-radio__label{
	color: #0B318F;
}
>>> .date_err .el-input--suffix .el-input__inner{
	border: 1px solid #c87872;
}
/* >>> .form_box .el-date-table td.current:not(.disabled) span{
	background-color: #0B318F !important;
}
>>> .form_box .el-date-table td.today span{
	color: #0B318F !important;
} */
</style>
